import SettingsWheelIcon from './SettingsWheelIcon'

export default SettingsWheelIcon
